import { CardMedia, Icon, InputAdornment, Typography, useMediaQuery } from '@mui/material'
import { Box } from '@mui/system'
import AdxInput from 'components/custom/AdxInput'
import AdxSortTable from 'components/reusable/table/AdxSortTable'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import UpskillTable from 'pages/approval-center/components/UpskillTable'
import { useState } from 'react'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router'
import { getAllUpskillProgression } from 'services/api/modules/upskill/approval-center'
import { useDebouncedEffect } from 'services/hooks/useDebouncedEffect'

const UpskillProgression = () => {
  const navigate = useNavigate()
  const isLarge = useMediaQuery((theme) => theme.breakpoints.up('lg'))

  const tableColumn = [
    {
      id: 1,
      Header: 'Staff name',
      accessor: 'name',
      Cell: (props) => {
        const { value } = props

        return (
          <Box display="flex" alignItems="center" gap={2}>
            {props?.row?.original?.profile_image_url ? (
              <CardMedia
                component="img"
                sx={{
                  height: 45,
                  width: 45,
                  objectFit: 'cover',
                  borderRadius: '50%',
                }}
                src={props?.row?.original?.profile_image_url}
              />
            ) : (
              <Box
                width={'45px'}
                height={'45px'}
                borderRadius="50%"
                bgcolor="alternate.main"
                color="white.main"
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  textTransform: 'capitalize',
                }}
              >
                {value?.charAt(0)}
              </Box>
            )}

            <Box
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Typography variant={isLarge ? 'body1' : 'body2'}>{value}</Typography>
              <Icon
                sx={{
                  fontSize: 30,
                  color: 'light-gray-text.main',
                  display: isLarge ? 'none' : 'block',
                }}
              >
                chevron_right
              </Icon>
            </Box>
          </Box>
        )
      },
    },
    {
      id: 2,
      Header: 'Course Enrolled',
      accessor: 'course_enrollment',
      Cell: (props) => {
        const { value } = props

        return <Typography>{value}</Typography>
      },
    },
  ]
  // pagination
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  //search item
  const [searchItem, setSearchItem] = useState('')
  //   use this to send as parameter to api
  const [searchPost, setSearchPost] = useState('')
  const handleClearSearch = () => {
    setSearchItem('')
  }

  // set delay for search api
  useDebouncedEffect(
    () => {
      if (searchItem.length > 0) {
        setSearchPost(`&search=${searchItem}`)
      } else {
        setSearchPost('')
      }
    },
    [searchItem],
    1000
  )

  const {
    isLoading: upskillProgressionDataIsLoading,
    error: upskillProgressionDataIsError,
    data: upskillProgressionData,
  } = useQuery(
    ['upskillProgressionData', page, rowsPerPage, searchPost],
    async () => {
      const { data } = await getAllUpskillProgression(rowsPerPage, page + 1, searchPost)
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  const changePage = (item) => {
    navigate(`/app/appraisal-cycle/upskill-progression/${item.id}`, {
      state: {
        id: item.id,
        name: item.name,
      },
    })
  }

  return (
    <>
      <DashboardContainer headerTitle="Upskill Progression">
        <Box
          sx={{
            padding: '16px',
            backgroundColor: 'white.main',
            borderRadius: '4.5px 4.5px 0 0',
            border: '1px solid #E5E5E5',
            borderBottom: 0,
          }}
        >
          <AdxInput
            placeholder="Search name"
            value={searchItem}
            onChange={(e) => setSearchItem(e.target.value)}
            sx={{
              width: { xs: 1, sm: 1 / 2, lg: '40%' },
              backgroundColor: 'white.main',
            }}
            startAdornment={
              <InputAdornment position="start">
                <Icon>search</Icon>
              </InputAdornment>
            }
            endAdornment={
              searchItem ? (
                <InputAdornment position="end">
                  <Icon onClick={handleClearSearch} sx={{ color: 'error.main', cursor: 'pointer' }}>
                    close
                  </Icon>
                </InputAdornment>
              ) : null
            }
          />
        </Box>
        <AdxSortTable
          column={isLarge ? tableColumn : tableColumn.splice(0, 1)}
          data={upskillProgressionData?.data ?? []}
          nav={isLarge ? 'View' : null}
          onClick={changePage}
          divClick
          sx={{
            boxShadow: 'none',
            borderRadius: '0 0 4.5px 4.5px',
            border: '1px solid #E5E5E5',
          }}
          pagination
          count={upskillProgressionData?.meta?.total}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        {/* <UpskillTable
          column={tableColumn}
          data={upskillProgressionData?.data ?? []}
          nav="View"
          onClick={changePage}
          sxHeader
          sxNav
          sxCell
          error={upskillProgressionDataIsError}
          isLoading={upskillProgressionDataIsLoading}
          type={'staff'}
          lastPage={upskillProgressionData?.meta?.last_page}
          count={upskillProgressionData?.meta?.total}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        /> */}
      </DashboardContainer>
    </>
  )
}
export default UpskillProgression
